import { WebCADGlobal } from "../..";
import { ThreeView } from "../../../view3d/webcad";
import { ItemInfoCollection } from "../../collection";
import WebCADUtil from "../WebCADUtil";
import * as THREE from 'three';

export class Raycaster {

    constructor() {}

    /**
     * 3D座標における位置
     */
    static getPosition(iteminfo: ItemInfoCollection): THREE.Vector3 {
        const unit = ((v: number) => {
            return v / 1000;
        });

        const iteminfoX =  WebCADUtil.convertPixToMM(iteminfo.x);
        const iteminfoY = WebCADUtil.convertPixToMM(iteminfo.y);

        const model_center = ThreeView.get().wcItemmgr.GltfExtras.model_center;
        const center = WebCADGlobal.itemManager.changePoint(model_center[0], model_center[1]);

        const pos = new THREE.Vector2(iteminfoX, iteminfoY).clone().sub(new THREE.Vector2(center.x, center.y));
        const y = iteminfo.transformMatrix[13];
        const floorY = ThreeView.get().wcItemmgr.floorToHeight(iteminfo.floor);
        const h = unit(y);

        return new THREE.Vector3(unit(pos.x), h + floorY, unit(pos.y));
    }

    /**
     * 3D座標における向き
     */
    static getDirection(iteminfo: ItemInfoCollection): THREE.Vector3 {
        const element = iteminfo.transformMatrix;
        return new THREE.Vector3(element[8], element[9], element[10]).clone().normalize();
    }
}